export * from './src/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-carousel/index.js
// module id = 486
// module chunks = 4